module.exports = __webpack_public_path__ + "static/media/uprofile.224d7714.png";